import { apiClient } from "./apiClient";
import { handleApiResponse } from "./handleApiResponse";


export const request = async (endpoint, options = {}) => {
  try {
    const response = await apiClient(endpoint, options);
    return await handleApiResponse(response);
  } catch (error) {
    // 🔥 If apiClient throws (e.g. TypeError from fetch), it likely means a network error or server down.
    if (error instanceof TypeError) {
      window.dispatchEvent(new CustomEvent("server-unreachable"));
    }
    throw error;
  }
};